// extracted by mini-css-extract-plugin
module.exports = {"story-search-container":"story-search_story-search-container__1mB_4"};